let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4rCT8")).then(() => parcelRequire('864s3'));